// src/router/folha-contabilidade.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['departamento_pessoal', 'peopleCulture']

const folhaContabilidadeBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Folha para a contabilidade',
    to: 'FolhaContabilidadeList'
  }
]

export default [
  {
    path: '/folha-contabilidade',
    name: 'FolhaContabilidadeList',
    component: () => import('@/views/PeopleCulture/FolhaContabilidade/ListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Folha para a contabilidade',
      breadcrumb: folhaContabilidadeBreadCrumb
    }
  },
  {
    path: '/folha-contabilidade/:id/edit',
    name: 'FolhaContabilidadeEdit',
    component: () => import('@/views/PeopleCulture/FolhaContabilidade/NovoPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Preenchimento da folha para a contabilidade',
      breadcrumb: [
        ...folhaContabilidadeBreadCrumb,
        {
          label: 'Preenchimento',
          to: 'FolhaContabilidadeEdit'
        }
      ]
    }
  }
]
